import { render, staticRenderFns } from "./FormAuth.vue?vue&type=template&id=a4d0b148&scoped=true&"
import script from "./FormAuth.vue?vue&type=script&lang=js&"
export * from "./FormAuth.vue?vue&type=script&lang=js&"
import style0 from "./FormAuth.vue?vue&type=style&index=0&id=a4d0b148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d0b148",
  null
  
)

export default component.exports